export default __webpack_public_path__ + "img/google.eae9aa93.svg";